import client from '../client';

const doctorApi = {
  list: ({ q, specialty, featured } = {}) => client.get('/doctors', { q, specialty, featured }),
  specialties: () => client.get('/doctors/specialties'),
  get: (id) => client.get(`/doctors/${id}`),
  /** Day summaries [{ date, status: available|few|full|closed, slotsOpen }] between two date keys. */
  availability: (id, { from, to, exclude }) => client.get(`/doctors/${id}/availability`, { from, to, exclude }),
  /** Earliest bookable days [{ date, time, slotsOpen, status }]. */
  earliest: (id, limit = 3) => client.get(`/doctors/${id}/earliest`, { limit }),
  /** Slots for one day [{ time: 'HH:mm', available }]. */
  slots: (id, date, { exclude } = {}) => client.get(`/doctors/${id}/slots`, { date, exclude }),
};

export default doctorApi;
